<div class="bg-dark-grey min-vh-100 d-flex flex-row align-items-center maintenance-page">
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="6" xl="5">
        <c-card-group>
          <c-card class="p-4 shadow-sm border-0">
            <c-card-body class="text-center">
              <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

              <div class="maintenance-icon mb-4">
                <svg cIcon name="cilSettings" size="3xl"></svg>
              </div>

              <h2 class="mb-3">{{ 'maintenance.title' | translate }}</h2>

              <p class="text-body-secondary mb-4">
                {{ 'maintenance.message' | translate }}
              </p>

              <p class="text-body-secondary small mb-0">
                {{ 'maintenance.try_again_later' | translate }}
              </p>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>
